import WorkTimeList from "./workTimeList/WorkTimeList";
import "./WorkTime.css";
import PrimaryButton from "../../../../sharedComponents/primaryButton/PrimaryButton";
import { Link } from "react-router-dom";

function WorkTime() {
    return (
        <>
            <div className="dashboard-work-time-header-container">
                <h2>Arbeitszeiten</h2>
                <Link to={"worktime/"}>
                    <PrimaryButton text="Alle Arbeitszeiten"/>
                </Link>
            </div>
            <div className="work-time-parent-container">
                <WorkTimeList />
            </div>
        </>
    )
}

export default WorkTime;